import { render, staticRenderFns } from "./AdobePdfEmbed.vue?vue&type=template&id=b09bedac"
import script from "./AdobePdfEmbed.vue?vue&type=script&lang=js"
export * from "./AdobePdfEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports